<template>
  <div class="login-box">
    <div class="has-text-centered">
      <h2 class="title">{{ $t('pages.loginRegister.login.title') }}</h2>
      <p class="subtitle">{{ $t('pages.loginRegister.login.subtitle') }}</p>
    </div>
    <div class="login-form">
      <form @submit.prevent="login">
        <b-field label="Email">
          <b-input v-model="email" placeholder="master@status.quo"
                   type="email"
                   icon="email">
          </b-input>
        </b-field>
        <b-field :label="$t('common.password')">
          <b-input v-model="password" placeholder="hardly crackable password"
                   type="password"
                   icon="key">
          </b-input>
        </b-field>
        <div class="has-text-centered">
          <button class="button is-light">{{ $t('buttons.login') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/services/bus'
import ApiAuth from '@/api/auth'
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      let body = {
        email: this.email,
        password: this.password
      }
      ApiAuth.post.login(body).then(response => {
        if (response.body.success) {
          // Store token in localStorage then add header for future requests
          window.localStorage.setItem('token', response.body.token)
          window.localStorage.setItem('username', response.body.user.username)
          this.$router.push({name: 'Home'})
          EventBus.$emit('isLoggedIn', true)
        } else {
          this.$snackbar.open({
            message: response.body.message,
            position: 'is-bottom-right',
            actionText: null
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  .login-form {
    margin-top: 20px;
  }
  input {
    width: 90%;
  }
  .field {
    margin-left: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue